import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { Button, Typography } from '@mui/material';
import { Direction, Range } from 'react-range';
import '../slider.css';
import { useState } from 'react';
import { IRange } from '../ISlider';


const CustomizedRange = ({
    minAmount,
    maxAmount,
    amountStep,
    setSelectedAmount,
    enableMode,
    defaultValue,
    selectedAmount,
    title
}: IRange) => {
    const [sliderValue, setSliderValue] = useState(defaultValue);

    // add btn for slider
    const handleIncrement = () => {
        setSliderValue((prevValue) => {
            const newValue = prevValue + amountStep!;
            const updatedValue = newValue > maxAmount ? maxAmount : newValue;

            setSelectedAmount(updatedValue);
            return updatedValue;
        });
    };

    const handleDecrement = () => {
        setSliderValue((prevValue) => {
            const newValue = prevValue - amountStep!;
            const updatedValue = newValue < defaultValue ? defaultValue : newValue;

            setSelectedAmount(updatedValue);
            return updatedValue;
        });
    };

    const handleChange = (newValue: number[]) => {
        let selectedValue = newValue[0];

        if (selectedValue >= defaultValue) {
            setSliderValue(selectedValue);
        }
    };
    return (
        <div className='flex flex-col gap-3'>
            <div className='flex justify-between '>
                <Typography className='text-[0.9rem] text-[var(--primary-text-color)]'>{title}</Typography>
                <Typography className='text-[0.875rem] text-[var(--text-gray-color)]'>{selectedAmount?.toLocaleString()} ریال </Typography>
            </div>
            <div
                dir='ltr'
                style={{
                    border: '1.5px solid var(--border-color)',
                    background: 'var(--input-bg-color)',
                    display: 'flex',
                    alignItems: 'center',
                    padding: "15px",
                    borderRadius: "5px"

                }}
            >

                <Button disableRipple disableFocusRipple disabled={!enableMode} sx={{
                    backgroundColor: 'transparent', width: "fit-content", height: "fit-content", padding: "0px", minWidth: "unset", "&:hover": {
                        backgroundColor: "transparent"
                    }
                }}>
                    <AddCircleIcon onClick={handleIncrement} sx={{ color: "#BBA57A", fontSize: '32px' }} />
                </Button>

                <div style={{ width: "100%", marginInline: "15px" }}>
                    <Range
                        disabled={!enableMode}
                        step={amountStep}
                        min={minAmount}
                        max={maxAmount}
                        values={[sliderValue]}
                        onChange={(values) => handleChange(values)}
                        onFinalChange={(values) => setSelectedAmount(values[0])}
                        draggableTrack={true}
                        direction={Direction.Left}
                        renderTrack={({ props, children }) => {
                            const percentage = ((sliderValue - minAmount) / (maxAmount - minAmount)) * 100;
                            return (
                                <div
                                    {...props}
                                    style={{
                                        height: "3px",
                                        background: `linear-gradient(to left, #BBA57A ${percentage}%, #D7DBEC ${percentage}%)`,
                                        width: "100%",
                                        borderRadius: "3px",

                                    }}
                                >
                                    {children}
                                </div>
                            );
                        }}
                        renderThumb={({ props }) => (
                            <div

                                {...props}
                                style={{
                                    width: '20px',
                                    height: '20px',
                                    background: '#BBA57A',
                                    borderRadius: '50%',

                                }}
                            />
                        )}
                    />
                </div>
                <Button disableRipple disableFocusRipple disableElevation disabled={!enableMode} sx={{ backgroundColor: 'transparent', width: "fit-content", height: "fit-content", padding: "0px", minWidth: "unset", "&:hover": { backgroundColor: "transparent" } }}>
                    <RemoveCircleIcon onClick={handleDecrement} sx={{ color: "#BBA57A", fontSize: '32px' }} />
                </Button>
            </div>
        </div>
    )
}

export default CustomizedRange
